import { useQuery } from "@tanstack/react-query";
import { fetchData } from "../fetchData";
import { DEFAULT_STALE_TIME, DEFAULT_CACHE_TIME } from "../../../shared/constants";
import useAuthStore from "../../../shared/store/useAuthStore";



export const useCheckUserExistance = (filters) => {
    return useQuery({
        queryKey: ["user/checkDetails", filters],
        queryFn: () => fetchData(`user/checkDetails`, filters),
        enabled: !!filters,
        staleTime: DEFAULT_STALE_TIME,
        cacheTime: DEFAULT_CACHE_TIME,
        refetchOnWindowFocus: false,
        refetchOnMount: true,
    });
};

export const useCheckMobileExistance = (filters) => {
    return useQuery({
        queryKey: ["user/checkDetails1", filters],
        queryFn: () => fetchData(`user/checkDetails`, filters),
        enabled: !!filters?.mobile,
        staleTime: DEFAULT_STALE_TIME,
        cacheTime: DEFAULT_CACHE_TIME,
        refetchOnWindowFocus: false,
        refetchOnMount: true,
    });
};

export const useSkillBoxWishlist = () => {
  return useQuery({
    queryKey: ["v1/wishlist/items"],
    queryFn: () => fetchData(`v1/wishlist/items`),
    staleTime: DEFAULT_STALE_TIME,
    cacheTime: DEFAULT_CACHE_TIME,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
  });
};

export const useSkillBoxCart = () => {
    return useQuery({
        queryKey: ["v1/cart"],
        queryFn: () => fetchData(`v1/cart`),
        staleTime: DEFAULT_STALE_TIME,
        cacheTime: DEFAULT_CACHE_TIME,
        refetchOnWindowFocus: false,
        refetchOnMount: true,
    });
};

export const useSkillBoxAddress = () => {
     const token = useAuthStore((state) => state.accessToken);
    return useQuery({
        queryKey: ["v1/address"],
        queryFn: () => fetchData(`v1/address`),
        enabled: !!token,
        staleTime: DEFAULT_STALE_TIME,
        cacheTime: DEFAULT_CACHE_TIME,
        refetchOnWindowFocus: false,
        refetchOnMount: true,
    });
};

export const useGetMilestones = (eventId) => {
    return useQuery({
        queryKey: ["milestones", eventId],
        queryFn: () =>
            fetchData(`v1/sv/courses/milestones`, {
                eventId,
            }),
        enabled: !!eventId,
        staleTime: DEFAULT_STALE_TIME,
        cacheTime: DEFAULT_CACHE_TIME,
        refetchOnWindowFocus: false,
        refetchOnMount: true,
    });
};

export const useStateCodeByCountry = (country_id, search) => {
    return useQuery({
        queryKey: ["all-states-list", country_id, search],
        queryFn: () =>
            fetchData("all-states-list", {
                country_id,
                search,
            }),
        enabled: !!country_id || !!search,
        staleTime: DEFAULT_STALE_TIME,
        cacheTime: DEFAULT_CACHE_TIME,
        refetchOnWindowFocus: false,
        refetchOnMount: true,
    });
};
